import { Button } from '@chakra-ui/react'
import { useAppSelector } from 'hooks/useAppSelector'
import { useProductsAndCategories } from 'hooks/useProductsAndCategories'
import { useTracker } from 'hooks/useTracker'
import type { Stepable } from 'interfaces'
import React from 'react'
import { useIntl } from 'react-intl'
import { useAppDispatch } from 'reduxStore'
import { addAddons, removeAddon } from 'reduxStore/ducks/storage/storageFlow'
import { InsuranceAddon } from 'routes/Common/Insurance'

const Addons = ({ onNextStep }: Stepable) => {
  const { formatMessage } = useIntl()
  const user = useAppSelector((state) => state.user.user)
  const addonsOrderlines = useAppSelector((state) => state.storageFlow.orderLines.addons)
  const coupon = useAppSelector((state) => state.storageFlow.coupon)
  const { isLoading, isError, error } = useProductsAndCategories({
    couponCode: coupon,
  })
  const dispatch = useAppDispatch()
  const tracker = useTracker()

  const handleClickOnNextStep = () => {
    onNextStep()
  }

  if (isError) {
    throw error
  }

  return (
    <>
      <InsuranceAddon
        coupon={coupon}
        addonsOrderlines={addonsOrderlines}
        onAddInsurance={(product) => dispatch(addAddons({ product, accountId: user?.id! }))}
        onRemoveInsurance={(product) =>
          dispatch(
            removeAddon({
              productId: product.id,
            })
          )
        }
      />

      <Button
        width="100%"
        onClick={() => {
          handleClickOnNextStep()
          tracker.selectAddons(addonsOrderlines)
        }}
        isLoading={isLoading}
        size="lg"
        variant="solid"
        colorScheme="ctaBlack"
        data-testid="continue-button"
      >
        {formatMessage({ id: 'booking.review' })}
      </Button>
    </>
  )
}

export { Addons }
